import { supabaseClient } from './supabaseClient.js';

// Lấy Global Budget (bản ghi duy nhất có category_id là null)
export async function fetchGlobalBudget() {
    const { data, error } = await supabaseClient
        .from('budgets')
        .select('*')
        .is('category_id', null)
        .eq('is_active', true)
        .single(); // Bắt buộc chỉ lấy 1 dòng
        
    if (error && error.code !== 'PGRST116') { 
        console.error('[API] Lỗi tải Global Budget:', error.message); 
    }
    return data || null;
}

// Lưu hoặc Cập nhật Global Budget
export async function saveGlobalBudget(monthlyAmount) {
    const { data: { user } } = await supabaseClient.auth.getUser();
    if (!user) return null;

    const existing = await fetchGlobalBudget();
    const now = new Date();
    const startDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;

    if (existing) {
        // Đã có -> Cập nhật số tiền
        const { data, error } = await supabaseClient
            .from('budgets')
            .update({ monthly_amount: monthlyAmount })
            .eq('id', existing.id)
            .select()
            .single();
        if (error) { console.error('[API] Lỗi sửa Budget:', error.message); return null; }
        return data;
    } else {
        // Chưa có -> Tạo mới (category_id tự động bỏ trống)
        const { data, error } = await supabaseClient
            .from('budgets')
            .insert([{ user_id: user.id, monthly_amount: monthlyAmount, start_date: startDate }])
            .select()
            .single();
        if (error) { console.error('[API] Lỗi tạo Budget:', error.message); return null; }
        return data;
    }
}

// Xóa Global Budget
export async function deleteGlobalBudget() {
    const existing = await fetchGlobalBudget();
    if (!existing) return true;

    const { error } = await supabaseClient
        .from('budgets')
        .update({ is_active: false })
        .eq('id', existing.id);
    if (error) { console.error('[API] Lỗi xóa Budget:', error.message); return false; }
    return true;
}